import React, { useEffect, useState } from 'react';
import Heart from 'assets/icons/trade/Heart.svg';
import { get } from 'scripts';
import { GetAllCoinType, Market, Pagination } from 'interfaces';
import { API } from 'data/30pay.api';
import { Spin } from 'antd';
import CoinIcon from 'utilities/components/coinIcon/coinIcon.index';
import { _CoinsProps } from '../convertBox/initial/coinsList/coinsList.interface';
import { MostPopularCoinCard } from './card/popularCoinCard.index';

export const MostPopularCoin = (props: { selectCoin: (coin: _CoinsProps) => void }) => {
    const [coins, setCoins] = useState<Market[]>();
    useEffect(() => {
        get<Market[]>(API.market.prices(1, 3), { Keywords: ['TRX', 'USDT', 'UUSD'] })
            .then((e) => {
                setCoins(e.value.value.filter((item) => item.symbol !== 'IRT'));
            })
            .catch((e) => console.log(e));
    }, []);
    return (
        <div className="flex-1 h-full w-full flex flex-col border border-primary-20 bg-white rounded-lg relative">
            <div className="flex min-h-14 items-center gap-2 px-5">
                <img src={Heart} alt="popular" />
                <h6>ارزهای محبوب</h6>
            </div>
            <div className="h-full p-4">
                <div className="flex-1 w-full h-full flex flex-col gap-5">
                    {coins ? (
                        coins.map((item, index) => (
                            <MostPopularCoinCard key={index} coin={item} selectCoin={props.selectCoin} />
                        ))
                    ) : (
                        <div className="w-full h-full absolute top-0 left-0 z-10 bg-white bg-opacity-50 flex items-center justify-center ">
                            <Spin size="large" />
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};
